// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"99":"component---themes-gatsby-theme-beluga-src-templates-index-tsx","389":"component---themes-gatsby-theme-beluga-src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"36":"b42da9683eb4bdd72ba0","99":"e54beef150434acd67e2","389":"1482f9790ac97fe7a17c","466":"39478a307a7109f01edf"}[chunkId] + ".js";
};